export const excludeMenuList = ['online-course', 'video'];